import { decodeDelimitedArray, encodeDelimitedArray, QueryParamConfig } from 'use-query-params';

type GenericStringType = string | (string | null)[] | null | undefined;

export const CommaArrayParam: QueryParamConfig<string[], string[]> = {
  encode: (array: string[]) => encodeDelimitedArray(array, ','),
  decode: (arrayStr: GenericStringType) => decodeDelimitedArray(arrayStr, ',') as string[],
};
